import { makeStyles, Box } from "@material-ui/core";

import { Icon } from "../../components/base/Icon";
import SolarIcon from "../../assets/images/icons/solar.svg";
import EVIcon from "../../assets/images/icons/ev-charge.svg";
import BatteryIcon from "../../assets/images/icons/battery.svg";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    width: 48,
    height: 48,
    borderWidth: 1,
    borderStyle: "solid",
    marginRight: 14,
    backgroundColor: COLORS.white,
  },
  battery: {
    borderColor: COLORS.majorelleBlue,
  },
  ev: {
    borderColor: COLORS.cian,
  },
  solar: {
    borderColor: COLORS.mikadoYellow,
  },
}));

export const PowerAssetIcon = ({ type }) => {
  const classes = useStyles();

  const getIconSrc = () => {
    switch (type.toLowerCase()) {
      case "battery":
        return BatteryIcon;
      case "ev":
        return EVIcon;
      case "solar":
        return SolarIcon;
      default:
        return BatteryIcon;
    }
  };

  return (
    <Box className={`${classes.icon} ${classes[type.toLowerCase()]}`}>
      <Icon src={getIconSrc()} />
    </Box>
  );
};
